/** Masks local part for OTP screen, e.g. `pat@example.com` → `p••••t@example.com`. */
export function maskEmailForOtpDisplay(email: string): string {
  const trimmed = email.trim().toLowerCase()
  const at = trimmed.indexOf("@")
  if (at <= 0) {
    return "your NetShield email"
  }
  const local = trimmed.slice(0, at)
  const domain = trimmed.slice(at + 1)
  if (!domain) {
    return "your NetShield email"
  }
  if (local.length <= 1) {
    return `••••@${domain}`
  }
  if (local.length === 2) {
    return `${local[0]}•@${domain}`
  }
  return `${local[0]}••••${local[local.length - 1]}@${domain}`
}
